import isEmpty from 'lodash/isEmpty';
import {RailsPdtConstants} from '../PdtHelper/RailsPdtConstants';
import { getRailsLanguageByKey } from '../../vernacular/AppLanguage';

const lang = () => getRailsLanguageByKey('cookieCode');

export const railsClientNewLogging = () => ({
  device: device(),
  user: user(),
  context: context(),
  traveller_details_list: null,
  traveller_details_railofy : null,
  rail_search_context: railSearchContext(),
  booking_details: bookingDetails(),
  rail_pricing_details: railPricingDetails(),
  applied_coupon_details: null,
  error_details_list: null,
  applicable_coupon_details_list: null,
  user_flow_blocker: { blocking_reason: null },
});

export const device = (data) => {
  if (isEmpty(data)) {
    return null;
  }
  const {
    type = null,
    model = null,
    id = null,
    connection_type = null,
    operating_system_version = null,
    operating_system = null,
    application_version = null,
    flavour = null
  } = data;
  return {
    type,
    operating_system,
    operating_system_version,
    model,
    id,
    carrier: null,
    latitude: null,
    longitude: null,
    browser: null,
    browser_version: null,
    connection_type,
    application_version,
    geo_city: null,
    user_agent: null,
    flavour
  };
};

export const user = (data) => {
  if (isEmpty(data)) {
    return {
      legacy_omniture_visitor_id: null,
      marketing_cloud_id: null,
      login_channel: null,
      is_logged_in: false,
      uuid: null,
      profile_type: null,
      email_communication_id: null,
      mobile_communication_id: null,
      is_email_verified: null,
      is_mobile_verified: null,
      email_id: null,
      city: null,
      is_black_opted: null,
      is_double_black_opted: null,
      black_status: null,
      double_black_status: null,
      is_corporate: null,
      is_corporate_admin: null,
      is_corporate_verified: null,
      wallet_bonus_balance: null,
      is_wallet_blocked: null,
      corporate_organization_id: null,
      is_corporate_policy_blocked: null,
      is_gst_selected: null,
      gst_registeration_number: null,
      gst_registered_company_name: null,
      loyalty_status: null,
      prime_status: null,
      mobile_country_code: null,
      wallet_cash_balance: null,
      wallet_balance_total: null,
      wallet_bonus_blocked_amount: null,
      wallet_bonus_expiry_amount: null,
      wallet_bonus_expiry_datetime: null,
      wallet_cash_expiry_datetime: null,
      wallet_cash_expiry_amount: null,
      wallet_real_balance: null,
      wallet_plus_balance: null,
    };
  }
  const {
    uuid = null,
    email_id = null,
    is_logged_in = null,
    login_channel = null,
    profile_type = null,
    is_mobile_verified = null,
    mobile_country_code = null,
    marketing_cloud_id = null,
    login_status = null,
    is_corporate = null,
  } = data;
  return {
    legacy_omniture_visitor_id: null,
    marketing_cloud_id,
    login_channel,
    is_logged_in,
    uuid,
    profile_type,
    email_communication_id: null,
    mobile_communication_id: null,
    is_email_verified: null,
    is_mobile_verified,
    email_id,
    city: null,
    is_black_opted: null,
    is_double_black_opted: null,
    black_status: null,
    double_black_status: null,
    is_corporate,
    is_corporate_admin: null,
    is_corporate_verified: null,
    wallet_bonus_balance: null,
    is_wallet_blocked: null,
    corporate_organization_id: null,
    is_corporate_policy_blocked: null,
    is_gst_selected: null,
    gst_registeration_number: null,
    gst_registered_company_name: null,
    loyalty_status: null,
    prime_status: null,
    mobile_country_code,
    wallet_cash_balance: null,
    wallet_balance_total: null,
    wallet_bonus_blocked_amount: null,
    wallet_bonus_expiry_amount: null,
    wallet_bonus_expiry_datetime: null,
    wallet_cash_expiry_datetime: null,
    wallet_cash_expiry_amount: null,
    wallet_real_balance: null,
    wallet_plus_balance: null,
  };
};

export const context = (data) => {
  if (isEmpty(data)) {
    return null;
  }
  const {
    client_timestamp = null,
    activity_name = null,
    page_name = null,
    funnel_step = null,
  } = data;
  return {
    topic_name: RailsPdtConstants.TopicId,
    template_id: RailsPdtConstants.TemplateId,
    is_columbus: true,
    correlation_key: null,
    lob_name: RailsPdtConstants.LobName,
    lob_code: null,
    server_timestamp: null,
    client_timestamp,
    client_ip: null,
    server_ip: null,
    domain: null,
    server_timezone: null,
    funnel_step,
    activity_name,
    omniture_page_name: null,
    page_name,
    flight_lob_name: null,
    api_version: null,
    api_context_name: null,
    row_id: null,
    api_name: null,
    search_session_key: null,
    session_mmt_id: null,
    session_id: null,
    environment: null,
    m124: client_timestamp,
    meta_act_nm: activity_name,
    domain_language: lang(),
  };
};

export const travellerDetailsList = (data) => {
  if (isEmpty(data)) {
    return [null,null];
  }
  const {
    email_communication_id = null,
    mobile_communication_id = null,
    first_name = null,
    confirmation_gurantee_available = null,
    zero_cancellation_available = null,
    confirmation_gurantee_opted = null,
    zero_cancellation_opted = null,
    confirmation_premium_variant = null,
    confirmation_gurantee_premium_amount = null,
    zero_cancellation_premium_amount = null,
    confirmation_probablity = null
  } = data;
  let traveller_details_list = [ {
      email_communication_id,
      mobile_communication_id,
      first_name,
      last_name: null,
      is_lead_traveller: null,
      pax_type: null,
      age: null,
      date_of_birth: null,
      nationality: null,
      title: null,
      gender: null,
      is_gst_selected: null,
      gst_registration_number: null,
      gst_registered_company_name: null,
      booking_status_type: null,
      booking_status: null,
    } ];
  let traveller_details_railofy = {
    confirmation_guarantee_available : confirmation_gurantee_available,
    zero_cancellation_available : zero_cancellation_available,
    confirmation_guarantee_opted : confirmation_gurantee_opted,
    zero_cancellation_opted: zero_cancellation_opted,
    confirmation_premium_variant: confirmation_premium_variant,
    confirmation_guarantee_premium_amount : confirmation_gurantee_premium_amount,
    zero_cancellation_premium_amount : zero_cancellation_premium_amount,
    confirmation_probablity : confirmation_probablity
  }

  return [traveller_details_list,traveller_details_railofy];
};

export const railSearchContext = (data) => {

  if (isEmpty(data)) {
    return null;
  }
  const {
    from_city_name = null,
    to_city_name = null,
    from_station_name = null,
    to_station_name = null,
    advance_purchase = null,
    boarding_station_name = null,
    duration = null,
    boarding_time = null,
    arrival_time = null,
    departure_time = null,
    from_city_cd = null,
    to_city_cd = null,
    from_station_cd = null,
    to_station_cd = null,
    boarding_station_cd = null,
    journey_date = null,
    journey_class = null,
    train_name = null,
    train_number = null,
    quota = null,
    price = null,
    availability = null,
    availabilityType = null,
    waitListNumber = null,
    availability_last_updated = null,
    source_locus_code = null,
    source_locus_type = null,
    source_locus_city_code = null,
    source_locus_station_code = null,
    source_locus_station_name = null,
    destination_locus_code = null,
    destination_locus_type = null,
    destination_locus_city_code = null,
    destination_locus_station_code = null,
    destination_locus_station_name =null
  } = data;
  return {
    from_city_name,
    to_city_name,
    from_station_name,
    to_station_name,
    advance_purchase,
    boarding_station_name,
    duration,
    boarding_time,
    arrival_time,
    departure_time,
    from_city_cd,
    to_city_cd,
    from_station_cd,
    to_station_cd,
    boarding_station_cd,
    journey_date,
    journey_class,
    train_name,
    train_number,
    quota,
    price,
    availability,
    availabilityType,
    waitListNumber,
    availability_last_updated,
    source_locus_code,
    source_locus_type,
    source_locus_city_code,
    source_locus_station_code,
    source_locus_station_name,
    destination_locus_code,
    destination_locus_type,
    destination_locus_city_code,
    destination_locus_station_code,
    destination_locus_station_name
  };
};

export const bookingDetails = (data) => {
  if (isEmpty(data)) {
    return null;
  }
  const {
    booking_created_timestamp = null,
    booking_transaction_id = null,
    booking_confirmation_status = null,
    total_amount = null,
    confirmation_gurantee_available = null,
    zero_cancellation_available = null,
    confirmation_gurantee_opted = null,
    zero_cancellation_opted = null,
    confirmation_premium_variant = null,
    confirmation_gurantee_premium_amount = null,
    zero_cancellation_premium_amount = null,
    confirmation_probablity = null
  } = data;
  return {
    booking_created_timestamp,
    booking_transaction_id,
    booking_confirmation_status,
    checkout_id: null,
    is_partial_amount_paid: null,
    is_coupon_applied: null,
    is_coupon_attached: null,
    is_wallet_applied: null,
    is_wallet_attached: null,
    is_fare_changed: null,
    fare_refreshed_amount: null,
    is_insurance_applied: null,
    is_insurance_attached: null,
    old_fare_amount: null,
    wallet_minimum_booking_amount: null,
    total_amount,
    payment_received_timestamp: booking_created_timestamp,
    confirmation_gurantee_available,
    zero_cancellation_available,
    confirmation_gurantee_opted,
    zero_cancellation_opted,
    confirmation_premium_variant,
    confirmation_gurantee_premium_amount,
    zero_cancellation_premium_amount,
    confirmation_probablity
  };
};

export const railPricingDetails = (data) => {
  if (isEmpty(data)) {
    return null;
  }
  const {
    ticket_charge = null,
    agent_service_charge_gst = null,
    irctc_insurance = null,
    irctc_service_charge = null
  } = data;

  return {
    ticket_charge,
    agent_service_charge_gst,
    irctc_insurance,
    irctc_service_charge
  };
};

export const applicableCouponDetailsList = (data) => {
  if (isEmpty(data)) {
    return null;
  }
  const {
    coupon_code = null,
    coupon_message = null,
    coupon_recommended_message = null,
    coupon_discount_amount = null,
    coupon_success_message = null,
    is_preapplied_coupon = null
  } = data;
  return {
    coupon_double_discount_applicable: null,
    coupon_code,
    coupon_message,
    coupon_verification_required: null,
    coupon_recommended_message,
    coupon_discount_amount,
    coupon_success_message,
    coupon_blocked_payment_modes: null,
    is_preapplied_coupon,
    coupon_type: null,
    coupon_hybrid_discount_details_list: couponHybridDiscountDetailsList(),
    coupon_payment_message: null
  };
};

export const appliedCouponDetails = (data) => {
  if (isEmpty(data)) {
    return null;
  }
  const {
    coupon_code = null,
    coupon_message = null,
    coupon_recommended_message = null,
    coupon_discount_amount = null,
    coupon_success_message = null
  } = data;

  return {
    coupon_double_discount_applicable: null,
    coupon_code,
    coupon_message,
    coupon_verification_required: null,
    coupon_recommended_message,
    coupon_discount_amount,
    coupon_success_message,
    coupon_blocked_payment_modes: null,
    coupon_type: null,
    coupon_hybrid_discount_details_list: couponHybridDiscountDetailsList(),
    coupon_payment_message: null
  };
};

export const errorDetailsList = () => ([{
  error_message: null,
  error_severity: null,
  error_source: null,
  error_code: null
}]);

export const insuranceDetailsList = () => ([{
  insurance_plan_code: null,
  insurance_amount: null,
  pax_type: null,
  insurance_price_type: null,
  insurance_stay_period: null,
  insurance_status: null,
  insurance_policy: null,
  insurance_error_message: null,
  insurance_error_code: null,
  insurance_plan_type: null
}]);

export const experimentDetailsList = () => ([{
  experiment_name: null,
  experiment_value: null
}]);

export const carCategoryVendorSelected = (data) => {
  if (isEmpty(data)) {
    return null;
  }

  const {
    vendor_price = null,
    vendor_rating = null,
    car_category = null
  } = data;

  return [{
    vendor_price,
    vendor_rating,
    vendor_cancellation_rate: null,
    car_category
  }];
};

export const carCategoryVendorNotSelected = () => ([{
  vendor_price: null,
  vendor_rating: null,
  vendor_cancellation_rate: null,
  car_category: null
}]);

export const itineraryDetailsList = (data) => {
  if (isEmpty(data)) {
    return null;
  }
  const {
    from_city_name = null,
    departure_date = null,
    from_country_name = null,
    to_country_name = null,
    from_city_code = null,
    departure_date_epoch = null,
    to_city_name = null,
    to_city_code = null
  } = data;
  return [{
    from_country_code: RailsPdtConstants.CountryCode,
    from_city_name,
    to_country_code: RailsPdtConstants.CountryCode,
    departure_date,
    from_country_name,
    to_country_name,
    from_city_code,
    departure_date_epoch,
    to_city_name,
    to_city_code
  }];
};

export const couponHybridDiscountDetailsList = () => ([{
  coupon_discount_type: null,
  coupon_time_of_credit: null,
  coupon_discount_code: null,
  coupon_discount_shared_by_partner: null,
  coupon_discount_shared_by_makemytrip: null
}]);
